<template>
  <div class="login">
    <div class="login-container">
      <el-form :model="loginForm" :rules="loginRules" ref="loginForm">
        <el-form-item prop="email">
          <el-input type="text" v-model="loginForm.email" auto-complete="off" placeholder="email"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model="loginForm.password" auto-complete="off" placeholder="pwd"></el-input>
        </el-form-item>
        <el-form-item style="width:100%;">
          <el-button type="primary" style="width:100%;" @click="submitLogin('loginForm')">Login</el-button>
        </el-form-item>
      </el-form>
    </div>

  </div>
</template>
<script>
  import {user_login} from "../api/api";
  import {setStore} from '../utils/util';

  export default {
    data() {
      return {
        activeName: 'login',

        loginForm: {
          email: '',
          password: ''
        },
        loginRules: {
          email: [
            {required: true, message: "please type email", trigger: "blur"},
            {type: 'email',message: 'type correct email',trigger: ['blur', 'change']}
          ],
          password: [{required: true, message: "please type password", trigger: "blur"}]
        }
      }
    },
    created() {
    },
    // 里面的函数只有调用才会执行
    methods: {
      // 登录
      submitLogin(editData) {
        this.$refs[editData].validate(valid => {
          if (valid) {
            this.submitLogin_();
          } else {
            return false;
          }
        });

      },
      async submitLogin_() {
        const userInfo = await user_login(this.loginForm)
        setStore("user", userInfo.data.token);
        if(userInfo.data.userType==1){
          this.$message({
            type: "error",
            message: "The account number mismatch!"
          });
        }else {
          this.$router.push({path: "/tree"});
        }
      },
    }
  }

</script>

<style>
  .login {
    height: 100%;
    width: 100%;
    background: url("../assets/img/login-bg.png") no-repeat bottom center;
    background-size: cover
  }

  .login-container {
    position: fixed;
    top: 30%;
    left: 50%;
    margin-left: -175px;
    width: 350px;
    border-radius: 6px;
    padding: 30px 35px 15px 35px;
    background: #f0f3f7;
    border: 1px solid #eaeaea;
    text-align: left;
  }

  .title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
  }
</style>



// WEBPACK FOOTER //
// src/views/login.vue